// angular
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { SolutionsPeopleBrowseComponent } from '@app/+solutions/components/solutions-people-browse/solutions-people-browse.component';

@Component({
  selector: 'pwj-installers',
  standalone: true,
  imports: [TranslateModule, SolutionsPeopleBrowseComponent],
  templateUrl: './installers.component.html',
  styleUrl: './installers.component.scss',
})
export class InstallersComponent {}
